import type { Editor, Range } from '@tiptap/core';

import type { CommentMentionTarget } from '@/types';

const insertCommentMention = (
    editor: Editor,
    range: Range,
    mention: CommentMentionTarget,
    nodeType = 'commentMention',
) =>
    editor
        .chain()
        .focus()
        .insertContentAt(range, [
            { attrs: mention, type: nodeType },
            { text: ' ', type: 'text' },
        ])
        .run();

export default insertCommentMention;
